import moment from "moment";

export const paginationrowsPerPageOptions = [5, 10, 30, 50];

export const formateDate = (date, formate = "DD-MM-YYYY") => {
    if (date && moment(date).isValid()) {
        return moment(date).format(formate);
    }
    return "-";
};
